/**
 * tco-model.js
 *
 * Modelul de calcul pentru calculatorul TCO auto (Cost Total de Deținere).
 * Portat 1:1 din implementarea WordPress de pe buhnici.ro/tco
 * (plugin buhnici-tco-calculator, assets/tco.js, funcția calc).
 *
 * SINGURA SURSA DE ADEVAR pentru formule. Rulează identic:
 *  - în browser, ca script clasic, expune window.TCOModel
 *  - în Node, prin tools/build-ssr.mjs, ca să genereze tabelul server-side
 *
 * Nu duplica logica asta în Liquid. Tabelul SSR se generează de aici.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.TCOModel = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /**
   * Cele 6 categorii de cost, cu etichetele și culorile din WordPress.
   * Cheile corespund exact câmpurilor întoarse de calc().
   */
  var CATEGORII = [
    { key: 'dep',  label: 'Depreciere',               col: '#64748b' },
    { key: 'ene',  label: 'Energie / combustibil',    col: '#2bd576' },
    { key: 'asig', label: 'Asigurări (RCA+CASCO)',    col: '#19b3ff' },
    { key: 'taxe', label: 'Taxe (impozit+rovinietă)', col: '#8b5cf6' },
    { key: 'intr', label: 'Întreținere + anvelope',   col: '#f5a524' },
    { key: 'alt',  label: 'Altele (spălat, parcare)', col: '#ec4899' }
  ];

  /** Etichete pentru tipurile de propulsie. HEV este modelat ca benzină. */
  var TYPE_LABEL = {
    electric: 'Electric',
    benzina: 'Benzină',
    diesel: 'Diesel',
    phev: 'Plug-in hybrid'
  };

  /**
   * Formula TCO, identică cu cea din WordPress.
   *
   * car     = { type, p: { pretAchizitie, pretRevanzare, consum, pretEnergie,
   *                        consumElectric, pretElectric, ratioElectric,
   *                        rcaAnual, cascoAnual, rovinieta, serviceAnual,
   *                        anvelope5ani, altele } }
   * ipoteze = { kmAn, ani, eur, prosumer }
   *
   * Unități: pretAchizitie și pretRevanzare în EUR (convertite prin ipoteze.eur),
   * restul valorilor deja în RON. anvelope5ani este cost total pe 5 ani.
   * Prosumator: la electric și la partea electrică a PHEV, prețul energiei
   * electrice devine 0. Nu afectează benzina sau motorina.
   */
  function calc(car, ipoteze) {
    var p = car.p;
    var km = ipoteze.kmAn;
    var ani = ipoteze.ani;
    var eur = ipoteze.eur;
    var pro = ipoteze.prosumer;
    var totalKm = km * ani;

    // Depreciere: diferența de preț (în EUR) convertită în RON.
    var dep = (p.pretAchizitie - p.pretRevanzare) * eur;

    // Energie / combustibil.
    var ene = 0;
    if (car.type === 'electric') {
      var price = pro ? 0 : p.pretEnergie;                 // RON/kWh
      ene = (p.consum / 100) * totalKm * price;
    } else if (car.type === 'phev') {
      var kmE = totalKm * (p.ratioElectric / 100);         // km pe electric
      var kmT = totalKm - kmE;                             // km pe termic
      var eP = pro ? 0 : p.pretElectric;
      ene = (p.consumElectric / 100) * kmE * eP + (p.consum / 100) * kmT * p.pretEnergie;
    } else {                                               // benzina / diesel (HEV = benzina)
      ene = (p.consum / 100) * totalKm * p.pretEnergie;    // RON/l
    }

    var asig = (p.rcaAnual + p.cascoAnual) * ani;
    var taxe = p.rovinieta * ani;
    var intr = p.serviceAnual * ani + p.anvelope5ani * (ani / 5);
    var alt = p.altele * ani;

    var total = dep + ene + asig + taxe + intr + alt;
    return {
      dep: dep, ene: ene, asig: asig, taxe: taxe, intr: intr, alt: alt, total: total,
      perKm: totalKm ? total / totalKm : 0,
      perLuna: total / (ani * 12),
      perAn: total / ani
    };
  }

  /** Rulează toate mașinile. Fiecare rezultat păstrează mașina și indexul ei. */
  function ruleazaTot(cars, ipoteze) {
    return cars.map(function (car, i) {
      var r = calc(car, ipoteze);
      r.car = car;
      r.index = i;
      return r;
    });
  }

  /**
   * Ordonează crescător după criteriu. Ca în WordPress, 'total' și 'luna'
   * dau aceeași ordine, fiindcă perLuna este total împărțit la o constantă.
   */
  function ordoneaza(rezultate, sortBy) {
    var arr = rezultate.slice();
    arr.sort(function (a, b) {
      if (sortBy === 'km') return a.perKm - b.perKm;
      return a.total - b.total;
    });
    return arr;
  }

  /** Mașina cu cel mai mic cost total. Badge-ul "cel mai ieftin" din WordPress. */
  function celMaiIeftin(rezultate) {
    var best = rezultate[0];
    for (var i = 1; i < rezultate.length; i++) {
      if (rezultate[i].total < best.total) best = rezultate[i];
    }
    return best;
  }

  return {
    CATEGORII: CATEGORII,
    TYPE_LABEL: TYPE_LABEL,
    calc: calc,
    ruleazaTot: ruleazaTot,
    ordoneaza: ordoneaza,
    celMaiIeftin: celMaiIeftin
  };
});
